// extracted by mini-css-extract-plugin
export default {"confirmation-modal__container":"confirmation-modal__container_i0h3q1S1"};